/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { FaCheck, FaFilter, FaPlus, FaTimes } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import {
  addInTab,
  addLinkItem,
  createItemFromTemplate,
  createNewItem,
  dupplicateItem,
  getSearch,
} from '../../services/item';
import { setOpenModales } from '../../store/global';
import { saveAll } from '../../store/items';
import {
  filterItemsByTemplateMode,
  getTemplateCreatedItemLabel,
  shouldCreateFromTemplateSelection,
} from '../../utils/templateSearch';
import { BtnSimple } from '../form/btn.Simple';
import { Checkbox } from '../form/checkbox';
import { InputSimple } from '../form/input.Simple';
import { ModalGlobal } from '../modal/modal.Global';
import { useSyncedCampaignFilter } from '../../hooks/useSyncedCampaignFilter';
import { LinkSelectedTemplate } from './link.SelectedTemplate';

export const LinkNewBoard = props => {
  const { itemId, currentTabId, onAddToBoard } = props;

  const item = useSelector(state => state.items[itemId]);
  const tab = useSelector(state => state.items[currentTabId]);
  const items = useSelector(state => state.items);
  const listCampaignsId = useSelector(state => state.global.listCampaignsId);
  const dispatch = useDispatch();

  const [dupplicateCurrent, setDupplicateCurrent] = useState(false);
  const [searchedItemsList, setSearchedItemsList] = useState([]);
  const [newItemLabel, setNewItemLabel] = useState('');
  const [searchedItem, setSearchedItem] = useState('');
  const [showCampaignFilter, setShowCampaignFilter] = useState(false);
  const [templatesOnly, setTemplatesOnly] = useState(false);
  const [fallbackCampaignIds, setFallbackCampaignIds] = useState([]);
  const universeId = item?.type === 'universe' ? item?._id : item?.universe;
  const effectiveCampaignIds = useMemo(() => {
    if (Array.isArray(listCampaignsId) && listCampaignsId.length > 0) {
      return listCampaignsId;
    }
    return fallbackCampaignIds;
  }, [listCampaignsId, fallbackCampaignIds]);
  const [selectedCampaignIds, setSelectedCampaignIds] =
    useSyncedCampaignFilter(effectiveCampaignIds, 'item-search-campaigns');

  useEffect(() => {
    if (!universeId) {
      return;
    }
    if (Array.isArray(listCampaignsId) && listCampaignsId.length > 0) {
      return;
    }
    let cancelled = false;
    const loadCampaigns = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/items/allcampaigns/${universeId}`,
        );
        if (cancelled) {
          return;
        }
        const ids = Array.isArray(res?.data)
          ? res.data.map(campaign => campaign?._id).filter(Boolean)
          : [];
        setFallbackCampaignIds(ids);
      } catch (error) {
        if (!cancelled) {
          setFallbackCampaignIds([]);
        }
      }
    };
    loadCampaigns();
    return () => {
      cancelled = true;
    };
  }, [universeId, listCampaignsId]);
  const campaignOptions = useMemo(() => {
    if (!Array.isArray(effectiveCampaignIds)) {
      return [];
    }
    return effectiveCampaignIds
      .filter(Boolean)
      .map(id => ({ id, label: items?.[id]?.label || 'Dossier' }));
  }, [effectiveCampaignIds, items]);
  const visibleSearchedItemsList = useMemo(
    () => filterItemsByTemplateMode(searchedItemsList, templatesOnly),
    [searchedItemsList, templatesOnly],
  );
  const searchIn = {
    type: false,
    universe: true,
    world: true,
    campaign: false,
  };

  const addLinkInTab = async itemInList => {
    if (itemInList?._id) {
      dispatch(saveAll({ item: itemInList, log: 'link-new-board' }));
    }
    if (onAddToBoard) {
      onAddToBoard(itemInList);
    } else {
      addLinkItem(item, tab, itemInList._id, addInTab);
    }
    setNewItemLabel('');
    setSearchedItemsList([]);
    setSearchedItem('');
    setDupplicateCurrent(false);
    dispatch(setOpenModales({ id: 'addLink' + currentTabId, open: false }));
  };

  const search = async value => {
    const campaignFilterReady =
      Array.isArray(effectiveCampaignIds) && effectiveCampaignIds.length > 0;
    if (
      campaignFilterReady &&
      Array.isArray(selectedCampaignIds) &&
      selectedCampaignIds.length === 0
    ) {
      setSearchedItemsList([]);
      return;
    }
    const campaignsForSearch = campaignFilterReady
      ? selectedCampaignIds
      : undefined;
    const res = await getSearch(value, item, searchIn, campaignsForSearch, {
      isTemplate: templatesOnly,
    });
    if (Array.isArray(res)) {
      setSearchedItemsList(res);
    } else {
      setSearchedItemsList([]);
    }
  };

  const handleCreate = async () => {
    if (searchedItem) {
      if (shouldCreateFromTemplateSelection(searchedItem)) {
        await createItemFromTemplate(searchedItem, item, {
          label: newItemLabel || getTemplateCreatedItemLabel(searchedItem),
          callback: addLinkInTab,
        });
      } else if (dupplicateCurrent) {
        await dupplicateItem({
          ...searchedItem,
          label: `${searchedItem.label} [copie]`,
          alias: item.alias,
          callback: addLinkInTab,
        });
      } else {
        await addLinkInTab(searchedItem);
      }
    } else if (newItemLabel !== '') {
      await createNewItem(
        {
          label: newItemLabel,
          callback: addLinkInTab,
        },
        item
      );
    }
  };

  const clearSelectedTemplate = () => {
    setSearchedItem('');
    setSearchedItemsList([]);
    setDupplicateCurrent(false);
  };

  useEffect(() => {
    if (
      templatesOnly &&
      searchedItem &&
      !shouldCreateFromTemplateSelection(searchedItem)
    ) {
      setSearchedItem('');
      setNewItemLabel('');
      setDupplicateCurrent(false);
    }
  }, [templatesOnly, searchedItem]);

  return (
    <ModalGlobal
      idToOpen={'addLink' + currentTabId}
      title={`Ajouter un item à ${tab?.label}`}
    >
      <div className='w-full flex flex-wrap items-center'>
        <div className='w-full flex items-center gap-05'>
          <InputSimple
            className='flex-1 m-0'
            resetValue={newItemLabel}
            placeholder={"Nom de l'item"}
            onChange={e => {
              const value = e.target.value;
              setNewItemLabel(value);
              if (!shouldCreateFromTemplateSelection(searchedItem)) {
                setSearchedItem('');
                setSearchedItemsList([]);
              }
              search(value);
            }}
            onBlur={() => null}
          />
          {campaignOptions.length > 0 && (
            <button
              type='button'
              className={`shrink-0 transition hover:opacity-70 ${
                showCampaignFilter ||
                selectedCampaignIds.length !== campaignOptions.length
                  ? 'text-secondary'
                  : 'text-contrast text-opacity-70'
              }`}
              title='Filtrer les dossiers'
              onClick={() => setShowCampaignFilter(prev => !prev)}
            >
              <FaFilter />
            </button>
          )}
        </div>
        {campaignOptions.length > 0 && showCampaignFilter && (
          <div className='w-full mt-03 max-h-8 overflow-auto bg-main bg-opacity-40 rounded p-04 border border-main-d border-opacity-40'>
            {campaignOptions.map(option => {
              const checked = selectedCampaignIds.includes(option.id);
              return (
                <div
                  key={option.id}
                  className='py-02'
                >
                  <Checkbox
                    checked={checked}
                    size='sm'
                    label={option.label}
                    labelClassName='text-xs'
                    onChange={() =>
                      setSelectedCampaignIds(prev =>
                        prev.includes(option.id)
                          ? prev.filter(id => id !== option.id)
                          : [...prev, option.id],
                      )
                    }
                  />
                </div>
              );
            })}
          </div>
        )}
        <div className='w-full mt-05 flex justify-end'>
          <Checkbox
            checked={templatesOnly}
            size='sm'
            label='Afficher uniquement les templates'
            labelClassName='text-xs'
            onChange={checked => setTemplatesOnly(checked)}
          />
        </div>
        {shouldCreateFromTemplateSelection(searchedItem) && (
          <LinkSelectedTemplate
            item={searchedItem}
            onClear={clearSelectedTemplate}
          />
        )}
        <div className='w-full flex'>
          <div className='w-1/4'></div>
          <div>
            {visibleSearchedItemsList.map(searchItem => (
              <div
                key={searchItem._id}
                className='cursor-pointer flex gap-1 items-center'
                onClick={() => {
                  setSearchedItem(searchItem);
                  setNewItemLabel(
                    shouldCreateFromTemplateSelection(searchItem)
                      ? getTemplateCreatedItemLabel(searchItem)
                      : searchItem.label,
                  );
                  setSearchedItemsList([]);
                }}
              >
                <div className='flex-1'>
                  {searchItem.label} -{' '}
                  <span className='text-xs uppercase text-opacity-50 text-contrast'>
                    {searchItem.alias}
                  </span>
                  {shouldCreateFromTemplateSelection(searchItem) && (
                    <span className='ml-05 text-xs uppercase text-secondary'>
                      template
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {searchedItem && !shouldCreateFromTemplateSelection(searchedItem) && (
        <div
          className='flex justify-center items-center gap-05 cursor-pointer mt-1'
          onClick={() => setDupplicateCurrent(!dupplicateCurrent)}
        >
          {dupplicateCurrent ? <FaCheck /> : <FaTimes />} Dupliquer{' '}
          {searchedItem.label}
        </div>
      )}

      <div className='w-full flex justify-center mt-1'>
        <BtnSimple
          className='flex gap-1 items-center'
          disabled={newItemLabel === ''}
          onClick={() => handleCreate()}
        >
          <FaPlus />
          {shouldCreateFromTemplateSelection(searchedItem)
            ? `Créer "${newItemLabel || getTemplateCreatedItemLabel(searchedItem)}" depuis le template "${searchedItem.label}"`
            : searchedItem
            ? `Ajouter "${searchedItem.label}${
                dupplicateCurrent ? ' [copie]' : ''
              }" à ${tab?.label}`
            : `Ajouter "${newItemLabel}" à ${tab?.label}`}
        </BtnSimple>
      </div>
    </ModalGlobal>
  );
};
